var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-office-filter__sticky-wrapper" }, [
    !_vm.showFilters && !_vm.isDesktop
      ? _c("div", { staticClass: "c-office-filter__show-filters-banner" }, [
          !_vm.isDesktop
            ? _c(
                "div",
                { staticClass: "googlemapoffice", attrs: { id: "mobilemap" } },
                [
                  !_vm.isDesktop
                    ? _c("v-google-map", {
                        attrs: {
                          selectedPlaces: _vm.selectedPlaces,
                          selectedTypesOfBuildings:
                            _vm.selectedTypesOfBuildings,
                          minSize: _vm.minSize,
                          maxSize: _vm.maxSize,
                          objects: this.objects,
                          apiKey: this.apiKey,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "filter-find-local" }, [
            _c(
              "button",
              {
                staticClass: "filter-local-button",
                on: { click: _vm.toggleFilterPanel },
              },
              [
                _c("div", { staticClass: "container-filter-local" }, [
                  _c(
                    "span",
                    {
                      staticClass: "c-icon c-icon--xs slider-icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c("svg", [
                        _c("use", { attrs: { "xlink:href": "#icon-sliders" } }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "filter-local-text" }, [
                    _vm._v("Hitta lokal"),
                  ]),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.isFilterVisible
            ? _c("div", { staticClass: "filter-container" }, [
                _c("div", { staticClass: "overlay-content" }, [
                  _c("div", { staticClass: "filter-header" }, [
                    _c("h2", [_vm._v("Filtrera")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "close-filter-container" }, [
                      _c(
                        "button",
                        {
                          staticClass: "close-contact",
                          on: { click: _vm.toggleFilterPanel },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "c-icon c-icon--xs",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("svg", [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-close" },
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "filter-sections" }, [
                    _c("div", { staticClass: "filter-section" }, [
                      _c(
                        "div",
                        {
                          staticClass: "filter-title",
                          on: {
                            click: function ($event) {
                              return _vm.toggleDropdown(0)
                            },
                          },
                        },
                        [
                          _c("span", [_vm._v("Välj plats")]),
                          _vm._v(" "),
                          _vm.isOpen(0)
                            ? _c(
                                "span",
                                {
                                  staticClass: "c-icon c-icon--xs",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [
                                  _c("svg", [
                                    _c("use", {
                                      attrs: {
                                        "xlink:href": "#icon-chevron-up",
                                      },
                                    }),
                                  ]),
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass: "c-icon c-icon--xs",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [
                                  _c("svg", [
                                    _c("use", {
                                      attrs: {
                                        "xlink:href": "#icon-chevron-down",
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.activeFilter === "plats"
                        ? _c("div", { staticClass: "filter-content" }, [
                            _c(
                              "ul",
                              {
                                staticClass: "c-office-filter-mobile-dropdown",
                              },
                              _vm._l(_vm.cities, function (city) {
                                return _c(
                                  "div",
                                  [
                                    _c(
                                      "li",
                                      { staticClass: "c-office-filter__city" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.addRegions(city)
                                              },
                                            },
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.selectedPlaces,
                                                  expression: "selectedPlaces",
                                                },
                                              ],
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                value: city.value,
                                                checked: Array.isArray(
                                                  _vm.selectedPlaces
                                                )
                                                  ? _vm._i(
                                                      _vm.selectedPlaces,
                                                      city.value
                                                    ) > -1
                                                  : _vm.selectedPlaces,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a = _vm.selectedPlaces,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = city.value,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.selectedPlaces =
                                                          $$a.concat([$$v]))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.selectedPlaces =
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                    }
                                                  } else {
                                                    _vm.selectedPlaces = $$c
                                                  }
                                                },
                                              },
                                            }),
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(city.display) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.regions, function (region) {
                                      return region.group === city.display
                                        ? _c(
                                            "li",
                                            {
                                              staticClass:
                                                "c-office-filter__region",
                                            },
                                            [
                                              _c("label", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.selectedPlaces,
                                                      expression:
                                                        "selectedPlaces",
                                                    },
                                                  ],
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    value: region.value,
                                                    checked: Array.isArray(
                                                      _vm.selectedPlaces
                                                    )
                                                      ? _vm._i(
                                                          _vm.selectedPlaces,
                                                          region.value
                                                        ) > -1
                                                      : _vm.selectedPlaces,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.selectedPlaces,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = region.value,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.selectedPlaces =
                                                              $$a.concat([$$v]))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.selectedPlaces =
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                        }
                                                      } else {
                                                        _vm.selectedPlaces = $$c
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(region.display) +
                                                    "\n                                        "
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e()
                                    }),
                                  ],
                                  2
                                )
                              }),
                              0
                            ),
                          ])
                        : _c("div"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "filter-title",
                          on: {
                            click: function ($event) {
                              return _vm.toggleDropdown(1)
                            },
                          },
                        },
                        [
                          _c("span", [_vm._v("Välj lokal")]),
                          _vm._v(" "),
                          _vm.isOpen(1)
                            ? _c(
                                "span",
                                {
                                  staticClass: "c-icon c-icon--xs",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [
                                  _c("svg", [
                                    _c("use", {
                                      attrs: {
                                        "xlink:href": "#icon-chevron-up",
                                      },
                                    }),
                                  ]),
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass: "c-icon c-icon--xs",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [
                                  _c("svg", [
                                    _c("use", {
                                      attrs: {
                                        "xlink:href": "#icon-chevron-down",
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.activeFilter === "lokal"
                        ? _c("div", { staticClass: "filter-content" }, [
                            _c(
                              "ul",
                              {
                                staticClass: "c-office-filter-mobile-dropdown",
                              },
                              _vm._l(_vm.premiseType, function (premise) {
                                return _c("div", [
                                  _c(
                                    "li",
                                    { staticClass: "c-office-filter__place" },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.selectedTypesOfBuildings,
                                              expression:
                                                "selectedTypesOfBuildings",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            value: premise.value,
                                            checked: Array.isArray(
                                              _vm.selectedTypesOfBuildings
                                            )
                                              ? _vm._i(
                                                  _vm.selectedTypesOfBuildings,
                                                  premise.value
                                                ) > -1
                                              : _vm.selectedTypesOfBuildings,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.selectedTypesOfBuildings,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = premise.value,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectedTypesOfBuildings =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectedTypesOfBuildings =
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                }
                                              } else {
                                                _vm.selectedTypesOfBuildings =
                                                  $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(premise.display) +
                                            "\n                                        "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ])
                              }),
                              0
                            ),
                          ])
                        : _c("div"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "filter-title",
                          on: {
                            click: function ($event) {
                              return _vm.toggleDropdown(2)
                            },
                          },
                        },
                        [
                          _c("span", [_vm._v("Välj yta")]),
                          _vm._v(" "),
                          _vm.isOpen(2)
                            ? _c(
                                "span",
                                {
                                  staticClass: "c-icon c-icon--xs",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [
                                  _c("svg", [
                                    _c("use", {
                                      attrs: {
                                        "xlink:href": "#icon-chevron-up",
                                      },
                                    }),
                                  ]),
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass: "c-icon c-icon--xs",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [
                                  _c("svg", [
                                    _c("use", {
                                      attrs: {
                                        "xlink:href": "#icon-chevron-down",
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.activeFilter === "yta"
                        ? _c("div", { staticClass: "filter-content" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-office-filter__size-input-block",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-office-filter__size-input-heading",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    Välj önskad yta\n                                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-office-filter__size-input-wrapper",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-office-filter__size-input-container",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-office-filter__size-input-tag",
                                          },
                                          [_vm._v("Min")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.minSize,
                                              expression: "minSize",
                                            },
                                          ],
                                          staticClass:
                                            "c-office-filter__size-input",
                                          attrs: {
                                            type: "number",
                                            placeholder: "0",
                                          },
                                          domProps: { value: _vm.minSize },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.minSize = $event.target.value
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm._m(0),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-icon c-icon--xs c-office-filter-dropdown__toggle-icon",
                                        attrs: { "aria-hidden": "true" },
                                      },
                                      [
                                        _c("svg", [
                                          _c("use", {
                                            attrs: {
                                              "xlink:href": `#icon-minus`,
                                            },
                                          }),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-office-filter__size-input-container",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-office-filter__size-input-tag",
                                          },
                                          [_vm._v("Max")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.maxSize,
                                              expression: "maxSize",
                                            },
                                          ],
                                          staticClass:
                                            "c-office-filter__size-input",
                                          attrs: {
                                            type: "number",
                                            placeholder: "0",
                                          },
                                          domProps: { value: _vm.maxSize },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.maxSize = $event.target.value
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm._m(1),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _c("div"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "selected-tags" },
                    [
                      _vm._l(_vm.displayTags, function (tag, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "selected-tag" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "close-tag",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeTag(tag.original)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "c-icon c-icon--xs",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _c("svg", [
                                      _c("use", {
                                        attrs: { "xlink:href": "#icon-close" },
                                      }),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "tag-container" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(tag.displayText) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.combinedTags.length > 4
                        ? _c("div", { staticClass: "show-all" }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    return _vm.resetFilter()
                                  },
                                },
                              },
                              [_vm._v("Visa alla")]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "result-button",
                      on: { click: _vm.submitFilters },
                    },
                    [
                      _vm._v(
                        "\n                    Visa resultat (" +
                          _vm._s(_vm.objects.length) +
                          ")\n                "
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showFilters || _vm.isDesktop
      ? _c(
          "div",
          {
            staticClass: "c-office-filter o-width-limiter--full",
            class: { "c-office-filter__mobile": !_vm.isDesktop },
          },
          [
            _c(
              "div",
              {
                staticClass: "c-office-filter__wrapper",
                class: { "c-office-filter__wrapper-mobile": !_vm.isDesktop },
              },
              [
                _c("div", { staticClass: "c-office-filter__content-wrapper" }, [
                  _c("h3", [_vm._v("Hitta lokal")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "c-office-filter__dropdown-wrapper" },
                    [
                      _c(
                        "v-office-filter-dropdown",
                        {
                          attrs: {
                            tag: "plats",
                            "button-text": _vm.placesButtonText,
                            "dropdown-open": this.activeFilter === "plats",
                          },
                          on: { "populate-filter": _vm.handleFilterData },
                        },
                        [
                          this.activeFilter === "plats"
                            ? _c(
                                "ul",
                                {
                                  directives: [
                                    {
                                      name: "click-outside",
                                      rawName: "v-click-outside",
                                      value: _vm.handleClickOutside,
                                      expression: "handleClickOutside",
                                    },
                                  ],
                                  staticClass: "c-office-filter-dropdown__list",
                                },
                                _vm._l(_vm.cities, function (city) {
                                  return _vm.activeFilter === "plats"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-office-filter__city-wrapper",
                                        },
                                        [
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "c-office-filter__city",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addRegions(
                                                        city
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.selectedPlaces,
                                                        expression:
                                                          "selectedPlaces",
                                                      },
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      value: city.value,
                                                      checked: Array.isArray(
                                                        _vm.selectedPlaces
                                                      )
                                                        ? _vm._i(
                                                            _vm.selectedPlaces,
                                                            city.value
                                                          ) > -1
                                                        : _vm.selectedPlaces,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.selectedPlaces,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = city.value,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.selectedPlaces =
                                                                $$a.concat([
                                                                  $$v,
                                                                ]))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.selectedPlaces =
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                          }
                                                        } else {
                                                          _vm.selectedPlaces =
                                                            $$c
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(city.display) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.regions,
                                            function (region) {
                                              return region.group ===
                                                city.display
                                                ? _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "c-office-filter__region",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _c("label", [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.selectedPlaces,
                                                                expression:
                                                                  "selectedPlaces",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "checkbox",
                                                            },
                                                            domProps: {
                                                              value:
                                                                region.value,
                                                              checked:
                                                                Array.isArray(
                                                                  _vm.selectedPlaces
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.selectedPlaces,
                                                                      region.value
                                                                    ) > -1
                                                                  : _vm.selectedPlaces,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.selectedPlaces,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      region.value,
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.selectedPlaces =
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.selectedPlaces =
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                  }
                                                                } else {
                                                                  _vm.selectedPlaces =
                                                                    $$c
                                                                }
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                region.display
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                }),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-office-filter-dropdown",
                        {
                          attrs: {
                            tag: "lokal",
                            "button-text": _vm.typeOfBuildingButtonText,
                            "dropdown-open": this.activeFilter === "lokal",
                          },
                          on: { "populate-filter": _vm.handleFilterData },
                        },
                        [
                          this.activeFilter === "lokal"
                            ? _c(
                                "ul",
                                {
                                  directives: [
                                    {
                                      name: "click-outside",
                                      rawName: "v-click-outside",
                                      value: _vm.handleClickOutside,
                                      expression: "handleClickOutside",
                                    },
                                  ],
                                  staticClass: "c-office-filter-dropdown__list",
                                },
                                _vm._l(_vm.premiseType, function (premise) {
                                  return _vm.activeFilter === "lokal"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-office-filter__place-wrapper",
                                        },
                                        [
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "c-office-filter__place",
                                            },
                                            [
                                              _c("label", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.selectedTypesOfBuildings,
                                                      expression:
                                                        "selectedTypesOfBuildings",
                                                    },
                                                  ],
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    value: premise.value,
                                                    checked: Array.isArray(
                                                      _vm.selectedTypesOfBuildings
                                                    )
                                                      ? _vm._i(
                                                          _vm.selectedTypesOfBuildings,
                                                          premise.value
                                                        ) > -1
                                                      : _vm.selectedTypesOfBuildings,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.selectedTypesOfBuildings,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = premise.value,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.selectedTypesOfBuildings =
                                                              $$a.concat([$$v]))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.selectedTypesOfBuildings =
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                        }
                                                      } else {
                                                        _vm.selectedTypesOfBuildings =
                                                          $$c
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(premise.display) +
                                                    "\n                                    "
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-office-filter-dropdown",
                        {
                          attrs: {
                            tag: "yta",
                            "button-text": _vm.buildingSizeText,
                            "dropdown-open": this.activeFilter === "yta",
                          },
                          on: { "populate-filter": _vm.handleFilterData },
                        },
                        [
                          this.activeFilter === "yta"
                            ? _c(
                                "ul",
                                {
                                  directives: [
                                    {
                                      name: "click-outside",
                                      rawName: "v-click-outside",
                                      value: _vm.handleClickOutside,
                                      expression: "handleClickOutside",
                                    },
                                  ],
                                  staticClass: "c-office-filter-dropdown__list",
                                },
                                [
                                  _vm.activeFilter === "yta"
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-office-filter__size-input-block",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-office-filter__size-input-heading",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        Välj önskad yta\n                                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-office-filter__size-input-wrapper",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-office-filter__size-input-container",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-office-filter__size-input-tag",
                                                      },
                                                      [_vm._v("Min")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.minSize,
                                                          expression: "minSize",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "c-office-filter__size-input",
                                                      attrs: {
                                                        type: "number",
                                                        min: "0",
                                                        placeholder: "0",
                                                      },
                                                      domProps: {
                                                        value: _vm.minSize,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.minSize =
                                                            $event.target.value
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "c-office-filter__size-input-m2-tag",
                                                      },
                                                      [
                                                        _vm._v("m"),
                                                        _c("sup", [
                                                          _vm._v("2"),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-icon c-icon--xs c-office-filter-dropdown__toggle-icon",
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  },
                                                  [
                                                    _c("svg", [
                                                      _c("use", {
                                                        attrs: {
                                                          "xlink:href": `#icon-minus`,
                                                        },
                                                      }),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-office-filter__size-input-container",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-office-filter__size-input-tag",
                                                      },
                                                      [_vm._v("Max")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.maxSize,
                                                          expression: "maxSize",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "c-office-filter__size-input",
                                                      attrs: {
                                                        type: "number",
                                                        min: "0",
                                                        placeholder: "0",
                                                      },
                                                      domProps: {
                                                        value: _vm.maxSize,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.maxSize =
                                                            $event.target.value
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "c-office-filter__size-input-m2-tag",
                                                      },
                                                      [
                                                        _vm._v("m"),
                                                        _c("sup", [
                                                          _vm._v("2"),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "clear-choises-button",
                      on: { click: _vm.resetFilter },
                    },
                    [
                      _vm._v(
                        "\n                    Rensa val\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.isDesktop
                  ? _c(
                      "div",
                      { staticClass: "googlemapoffice", attrs: { id: "map" } },
                      [
                        _vm.isDesktop
                          ? _c("v-google-map", {
                              attrs: {
                                selectedPlaces: _vm.selectedPlaces,
                                selectedTypesOfBuildings:
                                  _vm.selectedTypesOfBuildings,
                                minSize: _vm.minSize,
                                maxSize: _vm.maxSize,
                                objects: this.objects,
                                apiKey: this.apiKey,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "c-office-filter__choices-container" }, [
              _c(
                "ul",
                { staticClass: "c-office-filter__list" },
                [
                  _vm._l(_vm.cities, function (city) {
                    return _vm.activeFilter === "plats"
                      ? _c(
                          "div",
                          { staticClass: "c-office-filter__city-wrapper" },
                          [
                            _c("li", { staticClass: "c-office-filter__city" }, [
                              _c(
                                "label",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.addRegionsMobile(city)
                                    },
                                  },
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedPlacesMobile,
                                        expression: "selectedPlacesMobile",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      value: city.value,
                                      checked: Array.isArray(
                                        _vm.selectedPlacesMobile
                                      )
                                        ? _vm._i(
                                            _vm.selectedPlacesMobile,
                                            city.value
                                          ) > -1
                                        : _vm.selectedPlacesMobile,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.selectedPlacesMobile,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = city.value,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selectedPlacesMobile =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selectedPlacesMobile = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selectedPlacesMobile = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(city.display) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.regions, function (region) {
                              return region.group === city.display
                                ? _c(
                                    "li",
                                    { staticClass: "c-office-filter__region" },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedPlacesMobile,
                                              expression:
                                                "selectedPlacesMobile",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            value: region.value,
                                            checked: Array.isArray(
                                              _vm.selectedPlacesMobile
                                            )
                                              ? _vm._i(
                                                  _vm.selectedPlacesMobile,
                                                  region.value
                                                ) > -1
                                              : _vm.selectedPlacesMobile,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.selectedPlacesMobile,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = region.value,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectedPlacesMobile =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectedPlacesMobile =
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                }
                                              } else {
                                                _vm.selectedPlacesMobile = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(region.display) +
                                            "\n                        "
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e()
                            }),
                          ],
                          2
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.premiseType, function (premise) {
                    return _vm.activeFilter === "lokal"
                      ? _c(
                          "div",
                          { staticClass: "c-office-filter__place-wrapper" },
                          [
                            _c(
                              "li",
                              { staticClass: "c-office-filter__place" },
                              [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.selectedTypesOfBuildingsMobile,
                                        expression:
                                          "selectedTypesOfBuildingsMobile",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      value: premise.value,
                                      checked: Array.isArray(
                                        _vm.selectedTypesOfBuildingsMobile
                                      )
                                        ? _vm._i(
                                            _vm.selectedTypesOfBuildingsMobile,
                                            premise.value
                                          ) > -1
                                        : _vm.selectedTypesOfBuildingsMobile,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.selectedTypesOfBuildingsMobile,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = premise.value,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selectedTypesOfBuildingsMobile =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selectedTypesOfBuildingsMobile =
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selectedTypesOfBuildingsMobile =
                                            $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(premise.display) +
                                      "\n                        "
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm.activeFilter === "yta"
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "c-office-filter__size-input-block" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-office-filter__size-input-heading",
                              },
                              [
                                _vm._v(
                                  "\n                            Välj önskad yta\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-office-filter__size-input-wrapper",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-office-filter__size-input-container",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-office-filter__size-input-tag",
                                      },
                                      [_vm._v("Min")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.minSizeMobile,
                                          expression: "minSizeMobile",
                                        },
                                      ],
                                      staticClass:
                                        "c-office-filter__size-input",
                                      attrs: {
                                        type: "number",
                                        placeholder: "0",
                                      },
                                      domProps: { value: _vm.minSizeMobile },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.minSizeMobile =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm._m(2),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-icon c-icon--xs c-office-filter-dropdown__toggle-icon",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _c("svg", [
                                      _c("use", {
                                        attrs: { "xlink:href": `#icon-minus` },
                                      }),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-office-filter__size-input-container",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-office-filter__size-input-tag",
                                      },
                                      [_vm._v("Max")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.maxSizeMobile,
                                          expression: "maxSizeMobile",
                                        },
                                      ],
                                      staticClass:
                                        "c-office-filter__size-input",
                                      attrs: {
                                        type: "number",
                                        placeholder: "0",
                                      },
                                      domProps: { value: _vm.maxSizeMobile },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.maxSizeMobile =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm._m(3),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "c-office-filter__button-container" }, [
              _c(
                "button",
                {
                  staticClass: "c-office-filter__button-cancel",
                  on: {
                    click: function ($event) {
                      _vm.showFilters = !_vm.showFilters
                    },
                  },
                },
                [_vm._v("Avbryt")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "c-office-filter__button-save",
                  on: { click: _vm.applyFiltersMobile },
                },
                [_vm._v("Applicera")]
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "c-office-filter__size-input-m2-tag" }, [
      _vm._v("m"),
      _c("sup", [_vm._v("2")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "c-office-filter__size-input-m2-tag" }, [
      _vm._v("m"),
      _c("sup", [_vm._v("2")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "c-office-filter__size-input-m2-tag" }, [
      _vm._v("m"),
      _c("sup", [_vm._v("2")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "c-office-filter__size-input-m2-tag" }, [
      _vm._v("m"),
      _c("sup", [_vm._v("2")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }